import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'll-loanmgmt-bbc-display',
  templateUrl: './ll-loanmgmt-bbc-display.component.html',
  styleUrl: './ll-loanmgmt-bbc-display.component.css'
})
export class LlLoanmgmtBbcDisplayComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_loanmgmt_bbc_display') mainDiv!: ElementRef;
  @ViewChild('signatureInput') signatureInput!: ElementRef<HTMLInputElement>;
  @ViewChild('titleInput') titleInput!: ElementRef<HTMLInputElement>;

  bundle = {
    showDisplay: false,
    valueLock: false,
    showClientSig: false,
    showApprovalSig: false,
    showDelete: false,
    canDelete: false,
    canApproveBBC: false,
    canSignBBC: false,
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 80,
    panelW: 0,
    panelH: 0,
    records: [] as any[],
    groupNames: [] as string[],
    LOANMODELBBCRECORDID:0,
    BBC_THROUGHDATE_NUM: 0,
    BBC_MONTHENDDATE_NUM: 0,
    COLLATCONFIGMSG: '',
    BBCLANGUAGE: '',
    BBCAPPROVALLANGUAGE: '',
    BBCLOGONAME: '',
    showSignaturePopup: false,
    signatureInputValue: '',
    BBCApprovalName: '',
    sigType: '',
    CONTACTFIRST: '',
    CONTACTLAST: '',
    titleInputValue: '',
    sigAndTitle: false,
    minDateString: '',
    maxDateString: '',
    signLabel: "Sign and Save BBC",
    approveLabel: "Sign and Accept BBC",
    emailSignedTo: '',
    emailApprovedTo:'',

  };

  // Tooltip support
  tooltipVisibility: { [key: string]: boolean } = {};
  tooltipPosition = { x: 0, y: 0 };
  sigType: 'client' | 'approve' | 'delete' = 'client';

  constructor(
    private LlModelsService: LlModelsService,
    private llPermissionsService: LlPermissionsService,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.setVars();
  }

  ngOnDestroy(): void { }

  setVars() {
    if (!this.mainDiv?.nativeElement?.parentElement?.parentElement) return;
    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;
    this.bundle.canDelete = this.llPermissionsService.check('deleteBBC');
    this.bundle.canApproveBBC = this.llPermissionsService.check('approveBBC');
    this.bundle.canSignBBC = this.llPermissionsService.check('signBBC');
    
    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW - 20;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY - 48;
      
      this.getData();
    }, 0);
  }

  getData() {

    this.bundle.LOANMODELBBCRECORDID = Number(this.LlModelsService.getActiveLOANMODELBBCRECORDID()) || 0;

    if (this.bundle.LOANMODELBBCRECORDID === 0) { 
      this.bundle.BBC_THROUGHDATE_NUM = Number(this.LlModelsService.getBBC_THROUGHDATE_NUM());
      this.bundle.BBC_MONTHENDDATE_NUM = Number(this.LlModelsService.getBBC_MONTHENDDATE_NUM());

      if (this.bundle.BBC_THROUGHDATE_NUM == null) {
        this.bundle.BBC_THROUGHDATE_NUM = 0;
      }

      if (this.bundle.BBC_MONTHENDDATE_NUM == null) {
        this.bundle.BBC_MONTHENDDATE_NUM = 0;
      }


    }

    //console.log("this.bundle.LOANMODELBBCRECORDID: " + this.bundle.LOANMODELBBCRECORDID)
    //console.log("BBC_THROUGHDATE_NUM - 93: " + this.bundle.BBC_THROUGHDATE_NUM)
    //console.log("BBC_MONTHENDDATE_NUM - 94: " + this.bundle.BBC_MONTHENDDATE_NUM)

    this.LlModelsService.NG_LL_model_loanMgmt_modelElementsIncluded_get(
      'bbc',
      this.bundle.BBC_THROUGHDATE_NUM,
      this.bundle.BBC_MONTHENDDATE_NUM,
      (records: any[]) => {
        this.bundle.records = records || [];

        //console.log(records)

        this.bundle.BBC_THROUGHDATE_NUM = records[0].BBC_THROUGHDATE_NUM;
        this.LlModelsService.setBBC_THROUGHDATE_NUM(this.bundle.BBC_THROUGHDATE_NUM);

        this.bundle.BBC_MONTHENDDATE_NUM = records[0].BBC_MONTHENDDATE_NUM;
        this.LlModelsService.setBBC_MONTHENDDATE_NUM(this.bundle.BBC_MONTHENDDATE_NUM);

        if (records.length > 0) {

          this.bundle.minDateString = records[0].MINDATESTRING;
          this.bundle.maxDateString = records[0].MAXDATESTRING;
          this.bundle.emailSignedTo = records[0].EMAILSIGNEDBBCTO
          this.bundle.emailApprovedTo = records[0].EMAILAPPROVEDBBCTO
          
          if (records[0].BBC_CLIENTSIG_EMAILYESNO === 'Yes') {
            this.bundle.signLabel = "Sign and Save BBC (Auto-Email)"
          }

          if (records[0].BBC_APPROVESIG_EMAILYESNO === 'Yes') {
            this.bundle.approveLabel = "Sign and Accept BBC (Auto-Email)"
          }

          if (
            records[0].BBCCLIENTSIGNATUREYESNO === 'Yes' ||
            records[0].BBCLENDERAPPROVEDYESNO === 'Yes'
          ) {
            this.bundle.valueLock = true;
          } else if (
            this.bundle.canSignBBC === true &&
            records[0].BBC_CLIENTSIG_REQUIREDYESNO === 'Yes' &&
            records[0].BBCCLIENTSIGNATUREYESNO === 'No' &&
            records[0].VALIDDATAYESNO === 'Yes'
          ) {
            this.bundle.showClientSig = true;
          } else if (
            this.bundle.canApproveBBC === true &&
            records[0].BBC_APPROVESIG_REQUIREDYESNO === 'Yes' &&
            records[0].BBCLENDERAPPROVEDYESNO === 'No' &&
            records[0].VALIDDATAYESNO === 'Yes'
          ) {
            this.bundle.showApprovalSig = true;
          }

          if (
            this.bundle.canDelete === true &&
            records[0].BBC_CLIENTSIG_REQUIREDYESNO === 'Yes' &&
            records[0].BBCCLIENTSIGNATUREYESNO === 'Yes'
          ) {
            this.bundle.showDelete = true;
          }

          ///this.bundle.showDelete = true;

          this.bundle.COLLATCONFIGMSG = records[0].COLLATCONFIGMSG;
          this.bundle.BBCLANGUAGE = records[0].BBCLANGUAGE;
          this.bundle.BBCAPPROVALLANGUAGE = records[0].BBCAPPROVALLANGUAGE;
          this.bundle.BBCLOGONAME = "assets/" + records[0].BBCLOGONAME;
        }

        this.bundle.groupNames.splice(0);

        for (let i = 0; i < records.length; i++) {
          if (this.bundle.groupNames.indexOf(records[i].GROUPNAME) === -1) {
            this.bundle.groupNames.push(records[i].GROUPNAME);
          }

          if (this.bundle.records[i].LOANELEMENTID === 36 ) {
            //this.bundle.BBC_THROUGHDATE_NUM = this.bundle.records[i].ELEMENTVALUE.replace(/-/g, '');
            //this.LlModelsService.setBBC_THROUGHDATE_NUM(this.bundle.BBC_THROUGHDATE_NUM)

            //console.log("BBC_THROUGHDATE_NUM - 36: " + this.bundle.records[i].ELEMENTVALUE)
          }

          if (records[i].LOANELEMENTID === 119) {
            this.bundle.BBC_MONTHENDDATE_NUM = this.bundle.records[i].ELEMENTVALUE.replace(/-/g, '');   
            //this.LlModelsService.setBBC_MONTHENDDATE_NUM(this.bundle.BBC_MONTHENDDATE_NUM);

            records[i].ELEMENTVALUE = this.formatYyyyMmDdToMmDdYyyy(records[i].ELEMENTVALUE);
          }
        }

       

        // IMPORTANT: Run calculations & formatting after data is loaded
        this.updateCalculatedElement();
      }
    );
  }


  formatYyyyMmDdToMmDdYyyy(yyyymmdd: string): string {
    if (!yyyymmdd || yyyymmdd.length !== 8 || isNaN(Number(yyyymmdd))) {
      return '';
    }
    const year = yyyymmdd.substring(0, 4);
    const month = yyyymmdd.substring(4, 6);
    const day = yyyymmdd.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  mmddyyyyToYyyymmdd(mmddyyyy: string): string {
    if (!mmddyyyy || typeof mmddyyyy !== 'string') return '';
    const parts = mmddyyyy.trim().split('/');
    if (parts.length !== 3) return '';
    const month = parts[0].padStart(2, '0');
    const day = parts[1].padStart(2, '0');
    const year = parts[2];
    if (month < '01' || month > '12' || day < '01' || day > '31' || year.length !== 4) {
      return '';
    }
    return `${year}${month}${day}`;
  }

  // ── Value formatting ──
  formatElementValue(value: any, type: string, LOANELEMENTID:number): string {
    if (LOANELEMENTID === 119 ||type === 'dropdown' || type === 'none') {
      return value?.toString() || '';
    }
    if (type === 'date') {
      if (value) {
        const date = new Date(value as any);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }
      }
      return 'Date Required';
    }

    let numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) numValue = 0;
    switch (type) {
      case 'dollars':
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(numValue);
      case 'decimal':
        return numValue.toFixed(2);
      case 'integer':
        return Math.floor(numValue).toString();
      default:
        return numValue.toString();
    }
  }


  private updateCalculatedElement(): void {
    if (!this.bundle.records) return;
    const element71 = this.bundle.records.find(r => r.LOANELEMENTID === 71);
    const element68 = this.bundle.records.find(r => r.LOANELEMENTID === 68);
    if (element71 && element68 && element71.LOANGROUPID === 13) {
      const group13Records = this.bundle.records.filter(r => r.LOANGROUPID === 13 && r.LOANELEMENTID !== 71 && r.ELEMENTVALUETYPE !== 'date' && r.ELEMENTVALUETYPE !== 'none');
      const total = group13Records.reduce((sum, record) => {
        const value = typeof record.ELEMENTVALUE === 'string' ? parseFloat(record.ELEMENTVALUE) : record.ELEMENTVALUE;
        if (isNaN(value)) return sum;
        return record.ELEMENTPLUSMINUS === 'plus' ? sum + value : sum - value;
      }, 0);
      const value68 = typeof element68.ELEMENTVALUE === 'string' ? parseFloat(element68.ELEMENTVALUE) : element68.ELEMENTVALUE;
      const calculatedValue71 = (isNaN(value68) ? 0 : value68) + total;
      element71.ELEMENTVALUE = calculatedValue71;

      const element39 = this.bundle.records.find(r => r.LOANELEMENTID === 39);
      const element61 = this.bundle.records.find(r => r.LOANELEMENTID === 61);

      if (element61) {
        const value61 = typeof element61.ELEMENTVALUE === 'string' ? parseFloat(element61.ELEMENTVALUE) : element61.ELEMENTVALUE;
        const group21Records = this.bundle.records.filter(r => r.LOANGROUPID === 21 && r.LOANELEMENTID !== 39 && r.LOANELEMENTID !== 61 && r.ELEMENTVALUETYPE !== 'date' && r.ELEMENTVALUETYPE !== 'none');
        const total21 = group21Records.reduce((sum, record) => {
          const value = typeof record.ELEMENTVALUE === 'string' ? parseFloat(record.ELEMENTVALUE) : record.ELEMENTVALUE;
          if (isNaN(value)) return sum;
          if (record.ELEMENTPLUSMINUS === 'plus') return sum + value;
          if (record.ELEMENTPLUSMINUS === 'minus') return sum - value;
          return sum;
        }, isNaN(value61) ? 0 : value61);
        const calculatedValue39 = total21;
        if (element39) {
          element39.ELEMENTVALUE = calculatedValue39;
        }
        let outstandingLoanBalance39 = calculatedValue39;

        const element73 = this.bundle.records.find(r => r.LOANELEMENTID === 73);
        const element70 = this.bundle.records.find(r => r.LOANELEMENTID === 70);
        if (element73 && element70) {
          const value71 = typeof element71.ELEMENTVALUE === 'string' ? parseFloat(element71.ELEMENTVALUE) : element71.ELEMENTVALUE;
          const value70 = typeof element70.ELEMENTVALUE === 'string' ? parseFloat(element70.ELEMENTVALUE) : element70.ELEMENTVALUE;
          const calculatedValue73 = Math.min(isNaN(value70) ? 0 : value70, isNaN(value71) ? 0 : value71);
          element73.ELEMENTVALUE = calculatedValue73;

          const element75 = this.bundle.records.find(r => r.LOANELEMENTID === 75);
          if (element75) {
            const value39 = outstandingLoanBalance39;
            const calculatedValue75 = isNaN(value39) ? outstandingLoanBalance39 : value39;
            element75.ELEMENTVALUE = calculatedValue75;
     
            const element76 = this.bundle.records.find(r => r.LOANELEMENTID === 76);
            if (element76) {
              const value73 = typeof element73.ELEMENTVALUE === 'string' ? parseFloat(element73.ELEMENTVALUE) : element73.ELEMENTVALUE;
              const value75 = typeof element75.ELEMENTVALUE === 'string' ? parseFloat(element75.ELEMENTVALUE) : element75.ELEMENTVALUE;
              const calculatedValue76 = (isNaN(value73) ? 0 : value73) - (isNaN(value75) ? 0 : value75);
              element76.ELEMENTVALUE = calculatedValue76;
         
              const element74 = this.bundle.records.find(r => r.LOANELEMENTID === 74);
              const element54 = this.bundle.records.find(r => r.LOANELEMENTID === 54);
              if (element74 && element54 && element70) {
                const value75 = typeof element75.ELEMENTVALUE === 'string' ? parseFloat(element75.ELEMENTVALUE) : element75.ELEMENTVALUE;
                const value54 = typeof element54.ELEMENTVALUE === 'string' ? parseFloat(element54.ELEMENTVALUE) : element54.ELEMENTVALUE;
                const calculatedValue74 = (isNaN(value75) ? 0 : value75) + (isNaN(value54) ? 0 : value54);
                element74.ELEMENTVALUE = calculatedValue74;

                const value70 = typeof element70.ELEMENTVALUE === 'string' ? parseFloat(element70.ELEMENTVALUE) : element70.ELEMENTVALUE;
                if (!isNaN(calculatedValue74) && !isNaN(value70) && calculatedValue74 > value70) {
                  element74.ELEMENTNOTE = 'Excess of Commitment';
                } else {
                  element74.ELEMENTNOTE = '';
                }
                if (element54) {
                  const element72 = this.bundle.records.find(r => r.LOANELEMENTID === 72);
                  if (element72) {
                    const value76 = typeof element76.ELEMENTVALUE === 'string' ? parseFloat(element76.ELEMENTVALUE) : element76.ELEMENTVALUE;
                    const value54 = typeof element54.ELEMENTVALUE === 'string' ? parseFloat(element54.ELEMENTVALUE) : element54.ELEMENTVALUE;
                    const calculatedValue72 = (isNaN(value76) ? 0 : value76) - (isNaN(value54) ? 0 : value54);
                    element72.ELEMENTVALUE = calculatedValue72;
                if (!isNaN(calculatedValue72) && calculatedValue72 < 0) {
                      element54.ELEMENTNOTE = 'Excess of Availability';
                    } else {
                      element54.ELEMENTNOTE = '';
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    this.finalFormatAllRecords();
  }


  private finalFormatAllRecords(): void {
    this.bundle.records.forEach(r => {
      r.formattedValue = this.formatElementValue(r.ELEMENTVALUE, r.ELEMENTVALUETYPE, r.LOANELEMENTID);
    });
    this.cdr.detectChanges();
  }

  onValueChange(item: any, newValue: string): void {
    let formattedValue = newValue;

    if (item.ELEMENTVALUETYPE === 'date' && item.LOANELEMENTID === 36) {
      let YYYYMMDD = formattedValue.replace(/-/g, '');
      this.bundle.BBC_THROUGHDATE_NUM = Number(YYYYMMDD);
      this.LlModelsService.setBBC_THROUGHDATE_NUM(this.bundle.BBC_THROUGHDATE_NUM) 
      this.getData(); // full refresh for date change
      return; // early exit - getData() will trigger updateCalculatedElement()

    } else if (item.ELEMENTVALUETYPE === 'date' && item.LOANELEMENTID === 119) {

      let YYYYMMDD = newValue.replace(/-/g, '');
      this.bundle.BBC_MONTHENDDATE_NUM = Number(YYYYMMDD);
      this.LlModelsService.setBBC_MONTHENDDATE_NUM(this.bundle.BBC_MONTHENDDATE_NUM);
      this.getData(); // full refresh
      return;

    } else if (['dollars', 'decimal', 'integer'].includes(item.ELEMENTVALUETYPE)) {
      formattedValue = newValue.replace(/[^0-9.-]/g, '');
    }

    item.ELEMENTVALUE = formattedValue;

    // Run calculations after every normal edit
    this.updateCalculatedElement();
  }

  onNoteChange(item: any, newValue: string): void {
    item.ELEMENTNOTE = newValue.trim();
    this.cdr.detectChanges();
  }

  getMONTHENDDATE_NUMOptions(item: any): { value: string; label: string }[] {
    const choicesStr = item.DROPCHOICES || '';
    if (!choicesStr.trim()) {
      return [{ value: '', label: 'No options available' }];
    }
    return choicesStr
      .split(',')
      .map((choice: string) => choice.trim())
      .filter((choice: string) => choice.length > 0)
      .map((choice: string) => {
        if (choice.includes(':')) {
          const [value, label] = choice.split(':', 2);
          return { value: value.trim(), label: label.trim() || value.trim() };
        }
        return { value: choice, label: choice };
      });
  }

  isSelected(optionValue: string, currentValue: any): boolean {
    if (currentValue == null || currentValue === '') return optionValue === '';
    return String(optionValue) === String(currentValue);
  }

  getInputPlaceholder(type: string): string {
    switch (type) {
      case 'dollars': return 'Enter amount ($)';
      case 'decimal': return 'Enter number (e.g. 12.34)';
      case 'integer': return 'Enter whole number';
      default: return 'Enter value';
    }
  }

  // ── Signature / Approval / Delete logic ──
  public signBBC(): void {
    this.bundle.valueLock = true;
    this.bundle.showSignaturePopup = false;
    this.bundle.signatureInputValue = '';
    this.save('clientSignature');
    this.cdr.detectChanges();
  }

  public approveBBCValues(): void {
    this.bundle.showSignaturePopup = false;
    this.bundle.signatureInputValue = '';
    this.save('approval');
    this.cdr.detectChanges();
  }

  public deleteBBC(): void {
    this.bundle.showSignaturePopup = false;
    this.LlModelsService.NG_LL_model_loanMgmt_modelBBC_delete(this.bundle.records);
  }

  public save(source: string): void {
    if (this.bundle.records && this.bundle.records.length > 0) {

      for (let i = 0; i < this.bundle.records.length; i++) {
       
        if (this.bundle.records[i].LOANELEMENTID === 36) {
          this.bundle.records[i].ELEMENTVALUE = this.bundle.records[i].ELEMENTVALUE.replace(/-/g, '');
          this.bundle.BBC_THROUGHDATE_NUM = this.bundle.records[i].ELEMENTVALUE;
          //this.LlModelsService.setBBC_THROUGHDATE_NUM(this.bundle.BBC_THROUGHDATE_NUM) 
        }

        if (this.bundle.records[i].LOANELEMENTID === 119) {
          this.bundle.records[i].ELEMENTVALUE = this.bundle.records[i].ELEMENTVALUE.replace(/-/g, '');
          this.bundle.BBC_MONTHENDDATE_NUM = this.bundle.records[i].ELEMENTVALUE;
          //this.LlModelsService.setBBC_MONTHENDDATE_NUM(this.bundle.BBC_MONTHENDDATE_NUM);
        }

      }



      this.LlModelsService.NG_LL_model_loanMgmt_modelElementValues_edit(
        (arr: any) => this.handleApproveCallback(arr, source),
        source,
        'bbc',
        this.bundle.records,
        this.bundle.BBC_THROUGHDATE_NUM,
        this.bundle.BBC_MONTHENDDATE_NUM
        
      );
    }
    this.cdr.detectChanges();
  }

  private handleApproveCallback(arr: any, source: string): void {
    this.bundle.BBCApprovalName = arr[0].BBCAPPROVALNAME;
    this.cdr.detectChanges();
  }

  public openSignaturePopup(type: 'client' | 'approve' | 'delete'): void {
    let user = this.LlModelsService.getActiveUser();
    this.bundle.sigType = type;
    this.bundle.CONTACTFIRST = user.CONTACTFIRST;
    this.bundle.CONTACTLAST = user.CONTACTLAST;
    this.bundle.showSignaturePopup = true;
    this.bundle.signatureInputValue = '';
    this.bundle.titleInputValue = '';
    this.bundle.sigAndTitle = false;

    setTimeout(() => {
      if (this.signatureInput) this.signatureInput.nativeElement.focus();
    }, 0);
    this.cdr.detectChanges();
  }

  public closeSignaturePopup(): void {
    this.bundle.showSignaturePopup = false;
    this.bundle.signatureInputValue = '';
    this.bundle.titleInputValue = '';
    this.cdr.detectChanges();
  }

  public isSignatureAndTitleValid() {
    if (this.signatureMatchesName() && this.bundle.titleInputValue.trim().length > 0) {
      this.bundle.sigAndTitle = true;
      this.bundle.records.forEach(record => {
        record.BBCCLIENTSIGNATUREYESNO = 'Yes';
      });
    } else {
      this.bundle.sigAndTitle = false;
      this.bundle.records.forEach(record => {
        record.BBCCLIENTSIGNATUREYESNO = 'No';
      });
    }
    this.cdr.detectChanges();
  }

  public signatureMatchesName(): boolean {
    const fullName = `${this.bundle.CONTACTFIRST} ${this.bundle.CONTACTLAST}`.trim();
    return this.bundle.signatureInputValue.trim().toLowerCase() === fullName.toLowerCase();
  }

  public onSignatureInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.bundle.signatureInputValue = input.value;
    this.bundle.records.forEach(record => {
      record.CLIENTSIG = this.bundle.signatureInputValue;
    });
    this.isSignatureAndTitleValid();
  }

  public onTitleInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.bundle.titleInputValue = input.value;
    this.bundle.records.forEach(record => {
      record.CLIENTTITLE = this.bundle.titleInputValue;
    });
    this.isSignatureAndTitleValid();
  }

  // Tooltip handlers
  showTooltip(event: MouseEvent, recordId: string) {
    this.tooltipPosition = {
      x: event.clientX + 12,
      y: event.clientY + 8
    };
    this.tooltipVisibility[recordId] = true;
    this.cdr.detectChanges();
  }

  hideTooltip(recordId: string) {
    this.tooltipVisibility[recordId] = false;
    this.cdr.detectChanges();
  }
}

